import React, { useEffect, useState, useCallback } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
import './ShopsMap.css';
import logoMarker from '../assets/logo192.png'; // Import du logo
import L from 'leaflet';

// Styles de cartes disponibles (vous pouvez choisir celui que vous préférez)
const mapStyles = {
  // Style moderne et épuré
  modern: {
    url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  },
};

// Modifié pour utiliser activeShopId
const getCustomIcon = (isActive) => {
  const size = isActive ? 40 : 32;
  return new Icon({
    iconUrl: logoMarker,
    iconSize: [size, size],
    iconAnchor: [size / 2, size], // Centre en bas
    className: `shop-marker ${isActive ? 'selected' : ''}`
  });
};

// Icône pour la position de l'utilisateur
const userIcon = new Icon({
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  shadowSize: [41, 41]
});

const getCoordinates = (shop) => {
  if (shop?.coordinates?.latitude && shop?.coordinates?.longitude) {
    return [shop.coordinates.latitude, shop.coordinates.longitude];
  }
  return null;
};

// Composant interne pour gérer le centrage de la carte
const MapEffect = ({ activeShopId, shops }) => {
  const map = useMap();

  useEffect(() => {
    if (activeShopId) {
      const shop = shops.find(s => s.id === activeShopId);
      const coordinates = getCoordinates(shop);
      if (coordinates) {
        map.flyTo(coordinates, 14, { // Zoom 14, et animation
          animate: true,
          duration: 0.8 // Durée de l'animation
        });
      }
    }
    // Optionnel: recentrer par défaut si aucun shop n'est actif ?
    // else { map.flyTo(defaultCenter, defaultZoom); } 

  }, [activeShopId, shops, map]);

  return null; // Ce composant ne rend rien visuellement
};

// Modifié pour accepter activeShopId
const ShopsMap = ({ shops, activeShopId, onShopSelect }) => {
  const defaultCenter = [45.3789, 0.9292];  // Coordonnées d'Eyzerac
  const defaultZoom = 9;  // Zoom ajusté pour une vue régionale

  const handleMarkerClick = useCallback((shop) => {
    if (onShopSelect) {
      onShopSelect(shop);
    }
  }, [onShopSelect]);

  return (
    <div className="shops-map">
      <MapContainer 
        center={defaultCenter} 
        zoom={defaultZoom} 
        zoomControl={false}
        attributionControl={false}
      >
        <TileLayer
          url={mapStyles.modern.url}
          attribution={mapStyles.modern.attribution}
        />
        
        <MapEffect activeShopId={activeShopId} shops={shops} /> {/* Ajout du composant d'effet */}
        
        {shops.map(shop => {
          const coordinates = getCoordinates(shop);
          if (!coordinates) return null;

          return (
            <Marker 
              key={shop.id} 
              position={coordinates}
              // Utilise activeShopId pour déterminer si l'icône est active
              icon={getCustomIcon(activeShopId === shop.id)}
              eventHandlers={{
                click: () => handleMarkerClick(shop)
              }}
              // Augmenter le zIndex si l'icône est active pour qu'elle passe au dessus
              zIndexOffset={activeShopId === shop.id ? 1000 : 0}
            />
          );
        })}
      </MapContainer>
    </div>
  );
};

export default ShopsMap; 